import React from "react";
import { Card } from "react-bootstrap";
import CountUp from "react-countup";

const StatCard = ({ bgColor = "bg-soft-primary", svgIcon, value = 0, label = "" }) => {
  return (
    <Card className={bgColor}>
      <Card.Body>
        <div className="d-flex justify-content-between align-items-center">
          <div className={`${bgColor} rounded p-3`}>
            {svgIcon}
          </div>
          <div className="text-end">
            <h2 className="counter">
              <CountUp start={value - 50} end={value} duration={3} />
            </h2>
            {label}
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default StatCard;